import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentVerifiedFilledSize32Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M28 12c0-8-2.667-10.667-10.667-10.667H4v29.334h24zm-6-1.697L23.697 12 14 21.697 8.303 16 10 14.303l4 4z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
DocumentVerifiedFilledSize32Glyph.displayName = 'DocumentVerifiedFilledSize32Glyph';
